import { Component } from '@angular/core'
import { MbWishListService } from '../../wishlist/services/mb-wishlist.service'

@Component({
  selector: 'mb-my-account-wish-list',
  templateUrl: './mb-my-account-wish-list.component.html',
  styleUrls: ['./mb-my-account-wish-list.component.scss']
})
export class MbMyAccountWishListComponent {

  wishList$ = this.mbWishListService.getDefaultWishlist()

  constructor (protected mbWishListService: MbWishListService) { }
}
